import { Component, ViewChild, OnInit, Output, QueryList, ViewChildren,HostListener,EventEmitter,ElementRef } from '@angular/core';
import { ListService } from '../../../services/list.service';
import { Repository } from '../../../services/repository';
import { NgSelectComponent } from '@ng-select/ng-select';
import { ModalComponent } from 'ng2-bs3-modal/ng2-bs3-modal';
import {
  DanhMucs,Lists_nguonkinhphi, Lists_nhacungcap, Lists_chuong, Lists_loaikhoan, Lists_tieumuc, Lists_canbo, Lists_caphat, Lists_nghiepvu, Lists_nganhang, Lists_hoatdong, Lists_cmmt, Lists_mathongke,
  tiens_rutdutoan_ctuck, tiens_rutdutoan_ck, Lists_khachhang, Lists_taisancodinh, Lists_vattuhanghoa, Lists_congcudungcu, Lists_khohang,
  tonghops_dudauky, Lists_nhommucchi, Lists_phongban
} from '../../../routes/menu'
import 'jquery'
import 'bootstrap'


const swal = require('sweetalert');
@Component({
  selector: 'app-dutoan-chikhongtuchudmthietbiedit',
  templateUrl: './chikhongtuchudmthietbiedit.component.html',      
    providers: [ListService, Repository]
})


export class chikhongtuchudmthietbieditComponent implements OnInit {

   
  quyen_them: boolean = false;
  quyen_sua: boolean = false;
  quyen_xoa: boolean = false;
  quyen_themdoituong: boolean = false;
  quyen_themnguon: boolean = false;
  quyen_themchuong: boolean = false;
  quyen_themkhoan: boolean = false;
  quyen_themtieumuc: boolean = false;
  quyen_themcapphat: boolean = false;
  quyen_themnghiepvu: boolean = false;
  quyen_themnganhang: boolean = false;
  quyen_themctmt: boolean = false;
  quyen_themhoatdong: boolean = false;
  quyen_themthongke: boolean = false;
  quyen_themnhommuchi: boolean = false;
  quyen_themvattuhanghoa: boolean = false;
  quyen_themtaisan: boolean = false;
  quyen_themcongcu: boolean = false;
  indLoading: boolean = false;  
  
  //------------------------------
  inputtaikhoans: any;
  inputkhachhangs: any;
  inputnguonkinhphis: any;
  inputchuongs: any;
  inputcaphats: any;
  inputnghiepvus: any;
  inputnganhangs: any;
  inputhoatdongs: any;
  inputcmmts: any;
  inputthongkes: any;
  inputloaikhoans: any;
  inputtieumucs: any;
  inputlienquans: any;
  inputtaisans: any;
  inputhanghoas: any;
  inputhangcongcus: any;
  inputcongcus: any;
  inputkhohangs: any;
  inputphongbans: any;
  itemrow: any;
  //columns: any = [
  //  { Id: Lists_nguonkinhphi.id, Name: Lists_nguonkinhphi.text,Model:'Nguon_Id',BindValue:'Id',BindLabel:'Ten_Doi_Tuong', data: [], visible: true },
  //  { Id: Lists_loaikhoan.id, Name: Lists_loaikhoan.text, Model: 'Loai_Khoan_Id', BindValue: 'Id', BindLabel: 'Ten_Doi_Tuong', data: [], visible: true }
  //]
  columns: any = [];
  //---------------------------------
  chungtuSelect: any = {};

  public ngxCurrencyOptions = {
    prefix: '',
    thousands: '.',
    decimal: ',',
    precision: 0,
    allowNegative: false
  };
  onDoiTuongChange($event, hang: number) {
    var rs = this.chungtuSelect[hang];

    if (typeof $event === "undefined") {
      //rs.Don_Gia = 0;
    }
    else {
      rs.Don_Gia = $event.Gia_Dinh_Muc;
      if ($event.Gia_Dinh_Muc != null && $event.Gia_Dinh_Muc != 0) {
        rs.So_Tien = rs.Don_Gia * rs.So_Luong;
        rs.Ghi_Chu = $event.Ghi_Chu;
      }
    }

  }

  public changerange2(thutu: number) {

    //thutu = this.chungtuSelect.length - 1;
    this.itemrow = this.chungtuSelect[thutu];

    this.itemrow.So_Luong = (this.itemrow.Tien_Ve != null ? this.itemrow.Tien_Ve : 0)
      - (this.itemrow.Tien_O != null ? this.itemrow.Tien_O : 0);

    this.itemrow.So_Tien = (this.itemrow.So_Luong != null ? this.itemrow.So_Luong : 0)
      * (this.itemrow.Don_Gia != null ? this.itemrow.Don_Gia : 0);
    this.chungtuSelect[thutu] = this.itemrow;
  }

  public changerange(thutu: number) {

    //thutu = this.chungtuSelect.length - 1;
    this.itemrow = this.chungtuSelect[thutu];
    this.itemrow.So_Tien = (this.itemrow.So_Luong != null ? this.itemrow.So_Luong : 0)
      * (this.itemrow.Don_Gia != null ? this.itemrow.Don_Gia : 0);
    this.chungtuSelect[thutu] = this.itemrow;
  }

  @Output() save: EventEmitter<any> = new EventEmitter();
    constructor(  private repo: Repository) {
    }
  donviid: any;
  username: any;
  namketoan: any
  phanheid: any;

  isEdit: boolean = false;

  ngOnInit(): void {
    
    //----------------------lây thông tin ban đầu

    var crru = JSON.parse(localStorage.getItem('currentUser'));
    if (crru != null) {
      this.donviid = crru.id_don_vi;
      this.namketoan = crru.nam_ke_toan;
      this.username = crru.user_name;
      var giatri = crru.ds_quyen.filter(name => name.id === tonghops_dudauky.id.toLowerCase());
      if (giatri != null && giatri.length > 0) {
        if (giatri[0].them == true)
          this.quyen_them = true;
        else
          this.quyen_them = false;
        if (giatri[0].sua == true)
          this.quyen_sua = true;
        else
          this.quyen_sua = false;
        if (giatri[0].xoa == true)
          this.quyen_xoa = true;
        else
          this.quyen_xoa = false;
      }
      // gán quyền thêm đối tượng
      var giatri1 = crru.ds_quyen.filter(name => name.id === ('532A61EA-D765-844B-8CBF-E610B209E332').toLowerCase());
      if (giatri1 != null && giatri1.length > 0) {
        if (giatri1[0].them == true)
          this.quyen_themdoituong = true;
        else
          this.quyen_themdoituong = false;
      }
      giatri1 = crru.ds_quyen.filter(name => name.id === Lists_nguonkinhphi.id.toLowerCase());
      if (giatri1 != null && giatri1.length > 0) {
        if (giatri1[0].them == true)
          this.quyen_themnguon = true;
        else
          this.quyen_themnguon = false;
      }
      giatri1 = crru.ds_quyen.filter(name => name.id === Lists_chuong.id.toLowerCase());
      if (giatri1 != null && giatri1.length > 0) {
        if (giatri1[0].them == true)
          this.quyen_themchuong = true;
        else
          this.quyen_themchuong = false;
      }
      giatri1 = crru.ds_quyen.filter(name => name.id === Lists_loaikhoan.id.toLowerCase());
      if (giatri1 != null && giatri1.length > 0) {
        if (giatri1[0].them == true)
          this.quyen_themkhoan = true;
        else
          this.quyen_themkhoan = false;
      }
      giatri1 = crru.ds_quyen.filter(name => name.id === Lists_tieumuc.id.toLowerCase());
      if (giatri1 != null && giatri1.length > 0) {
        if (giatri1[0].them == true)
          this.quyen_themtieumuc = true;
        else
          this.quyen_themtieumuc = false;
      }
      giatri1 = crru.ds_quyen.filter(name => name.id === Lists_caphat.id.toLowerCase());
      if (giatri1 != null && giatri1.length > 0) {
        if (giatri1[0].them == true)
          this.quyen_themcapphat = true;
        else
          this.quyen_themcapphat = false;
      }
      giatri1 = crru.ds_quyen.filter(name => name.id === Lists_nghiepvu.id.toLowerCase());
      if (giatri1 != null && giatri1.length > 0) {
        if (giatri1[0].them == true)
          this.quyen_themnghiepvu = true;
        else
          this.quyen_themnghiepvu = false;
      }
      giatri1 = crru.ds_quyen.filter(name => name.id === Lists_nganhang.id.toLowerCase());
      if (giatri1 != null && giatri1.length > 0) {
        if (giatri1[0].them == true)
          this.quyen_themnganhang = true;
        else
          this.quyen_themnganhang = false;
      }
      giatri1 = crru.ds_quyen.filter(name => name.id === Lists_cmmt.id.toLowerCase());
      if (giatri1 != null && giatri1.length > 0) {
        if (giatri1[0].them == true)
          this.quyen_themctmt = true;
        else
          this.quyen_themctmt = false;
      }
      giatri1 = crru.ds_quyen.filter(name => name.id === Lists_hoatdong.id.toLowerCase());
      if (giatri1 != null && giatri1.length > 0) {
        if (giatri1[0].them == true)
          this.quyen_themhoatdong = true;
        else
          this.quyen_themhoatdong = false;
      }
      giatri1 = crru.ds_quyen.filter(name => name.id === Lists_mathongke.id.toLowerCase());
      if (giatri1 != null && giatri1.length > 0) {
        if (giatri1[0].them == true)
          this.quyen_themthongke = true;
        else
          this.quyen_themthongke = false;
      }
      giatri1 = crru.ds_quyen.filter(name => name.id === Lists_nhommucchi.id.toLowerCase());
      if (giatri1 != null && giatri1.length > 0) {
        if (giatri1[0].them == true)
          this.quyen_themnhommuchi = true;
        else
          this.quyen_themnhommuchi = false;
      }
      giatri1 = crru.ds_quyen.filter(name => name.id === Lists_vattuhanghoa.id.toLowerCase());
      if (giatri1 != null && giatri1.length > 0) {
        if (giatri1[0].them == true)
          this.quyen_themvattuhanghoa = true;
        else
          this.quyen_themvattuhanghoa = false;
      }
      giatri1 = crru.ds_quyen.filter(name => name.id === Lists_taisancodinh.id.toLowerCase());
      if (giatri1 != null && giatri1.length > 0) {
        if (giatri1[0].them == true)
          this.quyen_themtaisan = true;
        else
          this.quyen_themtaisan = false;
      }
      giatri1 = crru.ds_quyen.filter(name => name.id === Lists_congcudungcu.id.toLowerCase());
      if (giatri1 != null && giatri1.length > 0) {
        if (giatri1[0].them == true)
          this.quyen_themcongcu = true;
        else
          this.quyen_themcongcu = false;
      }



    }
    //-----------------------------------------------

    }





  public innerHeight: any;
  public taikhoan: any;
  public isHangHoa: number = 0;
  public indexRow: number;
  public loaichitieu: number;
  inputdoituongs: any
  loadDataInit(index: number, drow: any, tk: any)
  {
    this.indexRow = index;
    this.loaichitieu = drow.LoaiChiTieu;
    this.innerHeight = window.innerHeight - 150;

    this.repo.postRequest('api/doituong/dsdoituongkethuatheodoituongidv22', { NhomId: drow.Danh_Muc_Id, MaGiaoDien: '', DonViId: this.donviid, UserName: this.username, NamKeToan: this.namketoan })
      .subscribe(response => {
        this.inputdoituongs = response;
      });
    this.repo.getRequest("api/doituong/getall2/" + Lists_phongban.id + '/null/' + this.donviid)
      .subscribe(response => {
        this.inputphongbans = response;
      });
    
   
    this.chungtuSelect = tk;
    console.log(this.indexRow);
   
    setTimeout(() => {
      this.setComboFocus(0, 0);
    }, 1000);
  }
  earchFn(term: string, item: any) {
    term = term.toLowerCase();
    return item.Ma_Doi_Tuong.toLowerCase().indexOf(term) > -1 || item.Ten_Doi_Tuong.toLowerCase().indexOf(term) > -1;
  }
  RowNewClick() {
    var sp = 'bottom';
    if (this.chungtuSelect.length > 9)
      sp = 'top'

    this.chungtuSelect.push({
      showpopup: sp, Doi_Tuong_Id: null, ChiTieuThongKeId: null, Noi_Dung: null, Don_Vi_Tinh: null, So_Luong: null, Don_Gia: null, So_Tien: null, Ghi_Chu: null
      , Phong_Ban_Id: null, So_Nguoi: null, Tien_Khac: null, Tien_Ve: null, Tien_O: null
    });

  
  }
  deleterow(index: string, row: any) {
    console.log(index);
    swal({
      title: 'Bạn muốn xóa dòng này phải không?',
      text: 'Dữ liệu xóa sẽ không phục hồi lại được!',
      icon: "warning",
      buttons: {
        cancel: {
          text: 'Hủy bỏ',
          value: false,
          visible: true,
        },
        confirm: {
          text: 'Đồng ý',
          value: true,
          visible: true,
          className: "bg-danger",
          closeModal: true
        }
      }
    })
      .then(willDelete => {
        if (willDelete) {
          this.chungtuSelect.splice(index, 1);
          
        }
      });


  }
  maxcot: number = 11;

  keyComBoPress(event: any, hang: number, cot: number) {
    
    if (event.which === 13) {
      cot = cot + 1;

      if (cot > this.maxcot) {
        hang = hang + 1;
        cot = 0;

        if (hang === this.chungtuSelect.length) {
          this.RowNewClick();          
          cot = 0;
        }
      }
      this.setComboFocus(hang, cot);
      event.preventDefault();
    }
  }
  @ViewChildren("myinput") divs: QueryList<ElementRef>;
  @ViewChildren(NgSelectComponent) slcombo: QueryList<NgSelectComponent>
  //----------event xử lý di chuyển Enter--------------------------------------
  setComboFocus(hang: number, cot: number) {
    var tencombo: string = hang + '_' + cot ;

    if (cot === 5 || cot === 4) //---------so luong, don gia
    {
      console.log(tencombo);
      var row = this.chungtuSelect[hang];
      row.So_Tien = row.Don_Gia * row.So_Luong;
    }

    var ketqua = false;
    this.slcombo.forEach(
      (question, i, allQuestions) => {
        if (question.labelForId === tencombo) {
          ketqua = true;
          question.focus();
        }
      }
    );

    if (ketqua === false) {
      this.divs.forEach(
        (div) => {

          if (div.nativeElement.id === tencombo) {
            ketqua = true;
            div.nativeElement.focus();
          }

        }
      );
    }
  }
    
  public closeModal() {
    this.save.emit({ index: this.indexRow, loaichitieu: this.loaichitieu, data: this.chungtuSelect });
    }
  public savectu() {

    this.save.emit({ index: this.indexRow, loaichitieu: this.loaichitieu, data: this.chungtuSelect });
  }
  rowSelected: any = null;
  comboSeleted: NgSelectComponent;
  AddDoiTuong(cobo: NgSelectComponent, hang: number, cot: number) {

    this.comboSeleted = cobo;
    console.log(cobo)

    cobo.close();
    this.rowSelected = this.chungtuSelect[hang];


  }
   
  //------------------------------------
  
   


}

